import {Button, FormControl, Input, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {useEffect} from "react";
import {changePage, setFieldModel, setIsLeftToRight} from "../../../store/reducers";
import {useAppDispatch, useAppSelector} from "../../../hooks/use-store";
import {Resolver, useForm} from "react-hook-form";
import {ProducerModelQueryParamsNew} from "../../../data/model/Producer";
import {yupResolver} from "@hookform/resolvers/yup";
import {signupProducerSchemaTwoNew} from "../../../data/schema/signup";

export const SignupPageTwo = () => {
    const {currentPage, producer: producer} = useAppSelector((state) => state.landing);
    const dispatch = useAppDispatch();

    // const {producer} = producerData || {};
    const {name, address, phone, email, website, piva} = producer || {};

    const methods = useForm<ProducerModelQueryParamsNew>({
        mode: "all",
        resolver: yupResolver(signupProducerSchemaTwoNew) as Resolver<ProducerModelQueryParamsNew>
    });

    const {
        register,
        getValues,
        setValue,
        trigger,
        formState: {errors, isSubmitting, isValid}
    } = methods;

    function onSubmit() {
        const values = getValues()
        dispatch(setFieldModel(values));
        dispatch(setIsLeftToRight(false));
        dispatch(changePage((currentPage ?? 0) + 1));
    }

    useEffect(() => {
        if (name) {
            setValue("name", name);
            trigger("name");
        }

        if (address) {
            setValue("address", address);
            trigger("address");
        }

        if (phone) {
            setValue("phone", phone);
            trigger("phone");
        }

        if (email) {
            setValue("contactEmail", email);
            trigger("contactEmail");
        }

        if (website) {
            setValue("website", website);
            trigger("website");
        }

        if (piva) {
            setValue("piva", piva);
            trigger("piva");
        }
    }, [address, email, name, phone, piva, website]);

    return <VStack>
        <FormControl>
            <Text
                color={"primary.400"}
                alignSelf={"start"}
                fontSize={16}>Nome azienda (*)</Text>

            <Input
                id={"name"}
                focusBorderColor={!!errors.name ? "error.700" : "primary.400"}
                colorScheme={"primary"}
                variant='filled'
                _placeholder={{
                    fontSize: 14
                }}
                {...register('name')}
                placeholder='Es. Azienza S.r.l.'/>
            <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                {errors?.name && errors?.name.message}
            </Text>

            <Text
                color={"primary.400"}
                alignSelf={"start"}
                mt={"24px"}
                fontSize={16}>Indirizzo</Text>

            <Input
                id={"address"}
                focusBorderColor={!!errors?.address ? "error.700" : "primary.400"}
                variant='filled'
                colorScheme={"primary"}
                placeholder='Es. Via Roma 10, CT, 95100'
                _placeholder={{
                    fontSize: 14
                }}
                {...register('address')}
            />

            <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                {errors?.address && errors?.address.message}
            </Text>

            <Text
                color={"primary.400"}
                alignSelf={"start"}
                mt={"24px"}
                fontSize={16}>Recapito telefonico</Text>

            <Input
                id={"phone"}
                focusBorderColor={!!errors?.phone ? "error.700" : "primary.400"}
                variant='filled'
                colorScheme={"primary"}
                placeholder='Es. 095123456'
                _placeholder={{
                    fontSize: 14
                }}
                {...register('phone')}
            />

            <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                {errors?.phone && errors.phone.message}
            </Text>

            <Text
                color={"primary.400"}
                alignSelf={"start"}
                mt={"24px"}
                fontSize={16}>Email</Text>

            <Input
                id={"contact_email"}
                focusBorderColor={!!errors?.contactEmail ? "error.700" : "primary.400"}
                variant='filled'
                colorScheme={"primary"}
                placeholder='Es. azienza@mail.it'
                _placeholder={{
                    fontSize: 14
                }}
                {...register('contactEmail')}
            />

            <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                {errors?.email && errors?.email.message}
            </Text>

            <Text
                color={"primary.400"}
                alignSelf={"start"}
                mt={"24px"}
                fontSize={16}>Sito Web</Text>

            <Input
                id={"website"}
                focusBorderColor={!!errors?.website ? "error.700" : "primary.400"}
                variant='filled'
                colorScheme={"primary"}
                placeholder='Es. https://www.azienda.it'
                _placeholder={{
                    fontSize: 14
                }}
                {...register('website')}
            />

            <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                {errors?.website && errors?.website.message}
            </Text>

            <Text
                color={"primary.400"}
                alignSelf={"start"}
                mt={"24px"}
                fontSize={16}>Partita IVA</Text>

            <Input
                id={"partita_iva"}
                focusBorderColor={!!errors?.piva ? "error.700" : "primary.400"}
                variant='filled'
                colorScheme={"primary"}
                placeholder='Es. 86334519757'
                _placeholder={{
                    fontSize: 14
                }}
                {...register('piva')}
            />

            <Text fontSize={14} mt={"8px"} textColor={"error.700"}>
                {errors?.piva && errors.piva.message}
            </Text>
        </FormControl>

        {currentPage !== 3 && <Button
            isDisabled={!isValid}
            variant={"primary"}
            mt={"48px"}
            onClick={() => {
                onSubmit();
            }}
        >Avanti</Button>}

        {currentPage !== 0 && <Button
            variant={"tertiary"}
            {...currentPage !== 0 && {
                mb: "24px"
            }}
            mt={"8px"}
            onClick={() => {
                dispatch(setIsLeftToRight(true));
                dispatch(changePage((currentPage ?? 0) - 1));
            }}
        >Indietro</Button>}
    </VStack>
}
